<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.831 21.2474C11.5864 21.6921 9.25674 21.3052 7.27631 20.159L3.60424 21.3837C3.46581 21.4299 3.31726 21.4366 3.17523 21.403C3.0332 21.3695 2.90331 21.2971 2.80013 21.1939C2.69694 21.0907 2.62453 20.9608 2.59101 20.8188C2.55749 20.6768 2.56419 20.5282 2.61036 20.3898L3.83897 16.7215C2.69277 14.7409 2.30593 12.4112 2.75056 10.1665C3.19519 7.92179 4.44094 5.91542 6.25556 4.52143C8.07018 3.12744 10.3298 2.44098 12.6131 2.59004C14.8965 2.7391 17.0477 3.71351 18.6657 5.33158C20.2837 6.94965 21.2581 9.10096 21.4071 11.3844C21.5562 13.6678 20.8697 15.9276 19.4758 17.7423C18.0819 19.557 16.0756 20.8028 13.831 21.2474ZM13.1758 11.9964C13.1758 12.6473 12.6481 13.1749 11.9973 13.1749C11.3464 13.1749 10.8188 12.6473 10.8188 11.9964C10.8188 11.3455 11.3464 10.8178 11.9973 10.8178C12.6481 10.8178 13.1758 11.3455 13.1758 11.9964ZM7.67604 13.1749C8.32692 13.1749 8.85456 12.6473 8.85456 11.9964C8.85456 11.3455 8.32692 10.8178 7.67604 10.8178C7.02516 10.8178 6.49752 11.3455 6.49752 11.9964C6.49752 12.6473 7.02516 13.1749 7.67604 13.1749ZM17.497 11.9964C17.497 12.6473 16.9694 13.1749 16.3185 13.1749C15.6676 13.1749 15.14 12.6473 15.14 11.9964C15.14 11.3455 15.6676 10.8178 16.3185 10.8178C16.9694 10.8178 17.497 11.3455 17.497 11.9964Z"
    />
  </svg>
</template>
